import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { NavigationComponent } from './navigation/navigation.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CvComponent } from './cv/cv.component';
import { AppRoutingModule } from './app.routing';
import { WorksComponent } from './works/works.component';
import { MatCardModule } from '@angular/material/card';
import { PressComponent } from './press/press.component';
import { FooterComponent } from './footer/footer.component';
import { ContactComponent } from './contact/contact.component';

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    CvComponent,
    WorksComponent,
    PressComponent,
    FooterComponent,
    ContactComponent,
  ],
  imports: [BrowserModule, BrowserAnimationsModule, AppRoutingModule, MatCardModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}